module.exports = __webpack_public_path__ + "static/media/Hillrose_logo-red.c7f49cde.png";